import { useTranslation } from 'react-i18next';

import PageLayout from '../../layouts/PageLayout';
import Meta from '../../components/layout/Meta';
import MyProfileForm from '../../modules/forumMembers/UI/MyProfileForm';

function MyProfilePage() {
  const { t } = useTranslation();
  const pageTitle = t('forum_members.my_profile');

  return (
    <>
      <Meta title={pageTitle} />
      <PageLayout className="w-full" title={pageTitle}>
        <MyProfileForm />
      </PageLayout>
    </>
  );
}

export default MyProfilePage;
